// extracted by mini-css-extract-plugin
module.exports = {"recommend-help__content":"RecommendHelp_recommend-help__content__2CNeK"};